"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const _1 = __importDefault(require("./"));
const fonts_1 = require("./foundations/fonts");
const ThemeProvider = ({ children }) => (react_2.default.createElement(react_1.Flex, { flex: "1", id: "invoicing-renderer" },
    react_2.default.createElement(react_1.ChakraProvider, { cssVarsRoot: "#invoicing-renderer", theme: _1.default },
        react_2.default.createElement(fonts_1.Fonts, null),
        children)));
exports.ThemeProvider = ThemeProvider;
